export default {
  setActiveProgram(state, program) {
    state.activeProgram = program;
  },
};
